<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Editar usuario / Edit User</h5>
    <div mat-dialog-content>
        <!--begin::Form-->
        <form class="form" [formGroup]="editUserForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
            <mat-form-field class="w-100">
                <mat-label>Nombres / Names </mat-label>
                <input matInput type="text"
                  formControlName="name" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('name', 'required')">
                  <strong>Campo requerido / Required Field </strong>
                </mat-error>
              </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Apellidos / Last Name</mat-label>
                <input matInput type="text"
                  formControlName="lastname" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('lastname', 'required')">
                  <strong>Campo requerido / Required Field </strong>
                </mat-error>
              </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Cedula / ID</mat-label>
                <input matInput type="number"
                  formControlName="id" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('id', 'required')">
                  <strong>Campo requerido / Required Field </strong>
                </mat-error>
              </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Celular / Telefono / Phone / Mobile</mat-label>
                <input matInput type="text" [textMask]="{mask: mask}"
                  formControlName="userPhone" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('userPhone', 'required')">
                  <strong>Campo requerido / Required Field </strong>
                </mat-error>
              </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Correo electrónico / Email</mat-label>
              <input matInput type="text" style="text-transform:lowercase"
                     formControlName="userEmail" autocomplete="off"/>
                <mat-error *ngIf="isControlHasError('userEmail', 'required')">
                  <strong>Campo requerido / Required Field </strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('userEmail', 'email')">
                  <strong>Correo electrónico invalido / Invalid Email</strong>
                </mat-error>
            </mat-form-field>
        </div>
        </form>
        <!--end::Form-->
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick(false)">Cerrar / Cancel</button>
        <button mat-button cdkFocusInitial (click)="onNoClick(editUserForm)">Guardar / Save</button>
    </div>
</div>
